/**
 * Short IDs used for label barcodes (no 0, O, 1, I — Crockford-like alphabet).
 * Must match backend validation.
 */
export const SHORT_ID_ALPHABET = "BCDFGHJKLMNPQRSTVWXYZ23456789" as const;

const SHORT_ID_REGEX = new RegExp(
  `^[${SHORT_ID_ALPHABET}]{6,8}$`,
  "i",
);

/** True if the string could be a registered short ID (before API lookup). */
export function looksLikeShortId(raw: string): boolean {
  const t = raw.trim();
  if (t.length < 6 || t.length > 8) return false;
  return SHORT_ID_REGEX.test(t.toUpperCase());
}
